export default {
    diplomatic_mission_name: 'Diplomatic Mission Name',
    select: "Select",
    accompanied_by: 'I am accompanied by somebody',
    relation: 'Relation',
    select_language: "Select Language",
    language: "Language",
    select_visa_type: "Select Visa Type",
    select_country_of_passport: "Select country (Your passport issuing country)",
    select_document_holding_country: "Select Document Holding Country",
    select_country: "Select country",
    proceed: "Proceed",
    change_visa_type: "Change VISA Type",
    middle_name: "Middle Name",
    surname: "Surname",
    first_name: "First Name",
    full_name: "Full Name",
    name: "Name",
    country: "Country",
    late_stay_cost: 'Late stay cost',
    late_stay_days: "Late stay days",
    remaining_visa_year_days: 'Remaining visa year days',
    traveller_details: 'Traveller details',
    visa_expiry_date: 'Visa Expiry date',
    visa_start_date: 'Visa Start date',
    visa_end_date: 'Expiry Date',
    reason_for_extend: 'Reason for Extension',
    visa_period: "Visa Period",
    dob: "Date Of Birth (Year)",
    cancel: "Cancel",
    ok: "OK",
    gender: 'Gender',
    payment_info: "Payment Info",
    address_in_nepal: "Address In Nepal",
    appointment_date: "Appointment Date",
    full_address: "Full Address",
    address_of_institution: "Address of Institution",
    address: "Address",
    passport_number: "Passport No.",
    passport_validity: "Passport Validity",
    user_image: 'User image',
    arrived_from: 'Arrived point',
    passport_size_image: 'User Photo (Passport Size)',
    passport_image: 'Passport Scanned Copy',
    occupation: "Occupation",
    contact_tel: "Contact No.",
    purpose_of_visit: "Purpose Of Visit",
    purpose_of_visa: "Purpose Of Visa",
    cell_number: "Cell Phone Number",
    contact_number: 'Contact Number',
    contact_no_nepal: 'Contact Number of Nepal (Optional)',
    contact_no_nepal_required: 'Contact Number of Nepal *',
    passport_file: 'Passport File  *',

    confirmation: "Confirmation",
    confirm: "Confirm",
    back: "Back",
    validity_of_visa: "Validity Of Visa",
    visa_duration: "Visa Duration",
    visa_option: "Visa option",
    visa_cat_options: 'Visa category',
    document_type: 'Document type',
    visa_type_condition: 'Visa type condition',
    visa_condition: 'Visa condition',
    reason_for_convert: 'Reason for Conversion',
    document_number: 'Document number',
    document_expiry_date: 'Document Expiry Date',
    documents: 'Documents',
    document_validity: 'Document validity',
    personal_information: "Personal Info",
    name_of_association: "Name of the association institute",
    email: "Email (Optional)",
    email_required: "Email *",
    visa_req_from: "Visa Requested From Date",
    visa_req_to: "Visa Requested To Date",
    name_of_business_institute: "Name of the Business Institution",
    business_detail: "Business Detail",
    business_duration: "Duration of the Business",
    relationship: "Relationship",
    relationship_with_dependent: 'Relationship with host',
    from: "From",
    staying_at: "Staying At",
    hotel: "Hotel",
    other: "Other",
    place: "Place",
    position: "Position in the Organization",
    dependent_person_detail: "Host person details",
    arrival_airport: 'Last Airport',
    last_arriving_country: 'Last port of Call (LPC)',
    to: "To",
    husband: "Husband",
    organization_detail: "Organization Detail",
    organization_name: "Organization Name",
    select_organization_name: "Select Organization Name",
    address_of_organization: 'Address of Organization',
    father: "Father",
    mother: "Mother",
    wife: "Wife",
    citizenship: "Citizenship",
    citizenship_number: "Citizenship Number",
    district: "District",
    nepali_citizen_detail: "Nepalese citizen detail",

    marriage_visa_title: "Nepalese Spouse Detail",
    citizenship_image: "Citizenship File",
    visa_information: "Visa Information",
    marriage_details: "Marriage Details",
    date_of_marriage: "Date Of Marriage (AD)",
    place_of_marriage: "Place Of Marriage",

    relationship_person_detail: 'Details of Nepalese Kin / सनाखत गर्ने नेपाली नागरिकको विवरण',

    name_of_academic_institution: "Name of the Academic Institution",
    select_academic_institution: "Select Academic Institution",
    academic_institution: "Academic Institution",
    subject: "Subject",
    subject_to_study: "Subject to Study",
    total_cost: "Total Cost (USD)",
    apply_for_free: 'Apply for free',
    permanent_address_home_country: "Permanent Address (Home Country)",
    permanent_address: "Permanent Address",
    street_no: "Street No.",
    street_name: "Street Name",
    pin_number: "Pin Number",
    visa: "Visa",
    visa_cost: "Visa Cost(USD)",
    reason_for_the_visa: "Reason For The Visa",
    which_field: "Which Field?",
    mention: "Mention?",
    dataIterator: {
        rowsPerPageText: 'Items per page:',
        rowsPerPageAll: 'All',
        pageText: '{0}-{1} of {2}',
        noResultsText: 'No matching records found',
        nextPage: 'Next page',
        prevPage: 'Previous page'
    },
    dataTable: {
        rowsPerPageText: 'Rows per page:'
    },
    arrived_at: 'Arrived at',
    noDataText: 'No data available',
    visa_plan: 'Visa Plan',
    enter_visa_detail: 'Enter Visa Detail',
    visa_number: 'Visa Number',
    visa_type: 'Visa Type',
    current_visa_number: 'Current Visa Number',
    recommendation_letter: 'Recommendation letter',
    next_flight_number: 'Next flight number',
    has_recommendation_letter: 'I have recommendation letter for free visa',
    traveller_document_details: 'Traveller document details',
    traveller_document: 'Traveller document',

    arrived_from_country: 'Arrived from country',
    search: 'Search',
    existing_visa: 'You already have a visa which is not expired on this passport  (For more please reach out to any desk officer).',
    change_visa_to: 'Change Visa To',
    passport_type: 'Passport Type',
    days_staying: 'Days staying',
    visa_details: 'Visa Details',
    personal_details: 'Personal Details',
    passport_details: 'Passport Details',
    attached_document: 'Attached Documents',
    passport_expiry_date: 'Passport expiry date',
    next_destination_country: 'Next destination country',
    dependent_visa_number: 'Host visa number/Submission no',
    dependent_passport_number: 'Host passport number',
    proof_of_arrival: 'Proof of arrival to prove the date of Arrival (Bus Ticket/Air Ticket/Recommendations from the concerned Embassy/Consulate)',
    proof_of_departure: 'Proof of departure',
    reason_for_certification: 'Reason for certification',
    departure_country: 'Departure country',
    departure_from: 'Departure point',
    departure_at: 'Departure at',
    transfer_document_type: 'Document type ',
    transfer_document_number: ' number',
    transfer_document_validity: '  validity',
    file: ' File',
    visa_transfer_cost: 'Visa Transfer Cost (USD)',
    visa_transfer_details: 'Visa Transfer Details',
    reason_for_transfer: 'Reason for transfer ',
    reason_for_transfer_file: 'Reason for transfer file ',
    certification_details: 'Certification Details',
    police_report_or_recommendation: 'Police Report/Letter of Recommendation',
    document_file: 'Document file',

    select_office: 'Select your entry point',
    arrival_office: 'Entry Point',
    if_already_travelled_in_nepal: 'I have travelled to Nepal before',

    apply_office: 'Select your apply office',

    have_extra_passport: 'I have passport of another country as well',
    transport_no: "Flight/Bus No.",
    plan_upgrade_detail: 'Visa plan upgrade detail',
    update_cost: 'Update cost',
    proceed_with_bank_payment: 'Pay at Bank',
    // proceed_with_online_payment: 'Pay Via Card',
    pay_on_arrival: 'Pay on Arrival',
    charge_detail: 'Surplus  charge will be applied of 1$  while processing from online payment',
    i_am_nrn: 'I want to apply for NRN tourist gratis entry visa',
    i_am_nrn_citizenship: 'I want to apply for NRN Citizenship gratis entry visa',
    nrn_number: 'NRN number',
    nrn_citizenship: 'NRN Citizenship',
    read_the_instruction: 'Please follow the instruction below the application form.',
    are_you_sure: 'Are you sure ?',
    month: 'Month * ',
    dob_day: 'Date of Birth (AD)',
    passport_day: 'Passport Validity ',
    year: 'Year *',
    check_if_applicable: 'Check only if applicable (Optional)',
    places_to_visit_in_nepal: 'Places to visit in Nepal',
    new_visa_start_date: 'New visa start date',
    new_visa_end_date: 'New visa end date',
    contact_no: 'Contact number',
    apply_for_on_arrival_visa: 'Apply for on arrival visa',
    apply_for_entry_visa_processing: 'Apply for entry visa processing',
    apply_for_overstay: 'Apply for overstay visa',
    select_visa_category: 'Visa Category Selection',
    apply_for_business_working_conversion: 'Apply for Business / Working Visa Conversion',
    apply_for_relation_marriage_extension: 'Apply for Relation / Marriage Visa Extension',

}
